import { fetchPost, fetchGet, fetchPut, fetchPatch, fetchDelete } from '../services/Apiservice'

/**
 * Get payment list from API
 */
export const paymentList = (data) => {
    return fetchGet('/payment', data)
        .then((res) => res)
        .catch((err) => { throw err })
}

/**
 * Get payment details
 */
export const paymentDetail = (id) => {
    return fetchGet(`/payment/${id}`)
        .then((res) => res)
        .catch((err) => { throw err })
}

/**
 * Update payment details
 */
export const paymentUpdate = (id, data) => {
    return fetchPut(`/payment/${id}`, data)
        .then((res) => res)
        .catch((err) => { throw err })
}

/**
 * Update payment status
 */
export const paymentUpdateStatus = (id, status) => {
    return fetchPatch(`/payment/${id}/status`, { status })
        .then((res) => res)
        .catch((err) => { throw err })
}

/**
 * Refund a payment
 */
export const paymentRefund = (id, data = {}) => {
    return fetchPatch(`/payment/${id}/refund`, data)
        .then((res) => res)
        .catch((err) => { throw err })
}

/**
 * Delete a payment
 */
export const paymentDelete = (id) => {
    return fetchDelete(`/payment/${id}`)
        .then((res) => res)
        .catch((err) => { throw err })
}

/**
 * Get payment statistics
 */
export const paymentStatistics = () => {
    return fetchGet('/payment/statistics')
        .then((res) => res)
        .catch((err) => { throw err })
}

/**
 * Get payments by customer
 */
export const paymentByCustomer = (customerId, limit = 20) => {
    return fetchGet(`/payment/customer/${customerId}`, { limit })
        .then((res) => res)
        .catch((err) => { throw err })
}

/**
 * Init payment export — returns a one-time download key
 */
export const exportInit = (payload) => {
    return fetchPost('/payment/export/init', payload)
        .then((res) => res)
        .catch((err) => { throw err })
}

/**
 * Build the download URL from the key
 */
const API_BASE = import.meta.env.VITE_API_URL

export const exportDownloadUrl = (key) => {
    return `${API_BASE}/api/v1/payment/export/download/${key}`
}